import BANK_TRACKING from 'consts/bankTrackingConsts';
import {
  CREDIT_DECLINED_BY_USER_STATE,
  CREDIT_ENROLLMENT_FAILED_STATE,
  ENROLLMENT_DECLINED_STATE,
  ENROLLMENT_PENDING_STATE,
  ENROLLMENT_SUCCESSFUL_STATE,
} from 'consts/enrollmentCompletionStates';

const USER_REVIEW = 'user_review';

export const selectEnrollment = state => state.enrollment;

export const selectEnrollmentStatus = state =>
  state.enrollment && state.enrollment.status;

export const selectIsEnrollmentUserReview = state => {
  return state.enrollment?.status?.startsWith?.(USER_REVIEW) || false;
};

export const selectEnrollmentUserReviewStatus = state => {
  return state.enrollment?.status?.replace(`${USER_REVIEW}_`, '');
};

export const selectIsEnrollmentCompleteStatus = state =>
  state.enrollment &&
  [
    ENROLLMENT_DECLINED_STATE,
    ENROLLMENT_PENDING_STATE,
    ENROLLMENT_SUCCESSFUL_STATE,
  ].includes(state.enrollment.status);

export const selectEnrollmentInvalidEmailSubmitted = state => {
  const enrollment = selectEnrollment(state);
  return enrollment && enrollment.invalidEmailSubmitted;
};

export const selectEnrollmentEnrolledInCredit = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.enrolledInCredit;
};

export const selectEnrollmentCreditDeclinedByUser = state => {
  const enrollment = selectEnrollment(state);

  return (
    enrollment &&
    enrollment.creditStatus &&
    enrollment.creditStatus === CREDIT_DECLINED_BY_USER_STATE
  );
};

export const selectEnrollmentCreditFailed = state => {
  const enrollment = selectEnrollment(state);

  return (
    enrollment && enrollment.creditStatus === CREDIT_ENROLLMENT_FAILED_STATE
  );
};

export const selectEnrollmentSuccessAttributionSubmitted = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.successAttributionSubmitted;
};

export const selectEnrollmentBankDecision = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.bank;
};

export const selectEnrollmentIsStrideBankDebit = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.bank === BANK_TRACKING.stride.bank_variant;
};

export const selectEnrollmentIsBancorpBankDebit = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.bank === BANK_TRACKING.bancorp.bank_variant;
};

export const selectEnrollmentIsStrideBankCredit = state => {
  const enrollment = selectEnrollment(state);

  return (
    enrollment && enrollment.creditBank === BANK_TRACKING.stride.bank_variant
  );
};

export const selectEnrollmentIsBancorpBankCredit = state => {
  const enrollment = selectEnrollment(state);

  return (
    enrollment && enrollment.creditBank === BANK_TRACKING.bancorp.bank_variant
  );
};

export function selectEnrollmentWhichBankVariation(state) {
  if (selectEnrollmentIsStrideBankDebit(state)) {
    return 'Stride';
  } else if (selectEnrollmentIsBancorpBankDebit(state)) {
    return 'Bancorp';
  }

  return null;
}

export const selectEnrollmentRequirePhoneVerification = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.requirePhoneVerification;
};

export const selectEnrollmentRequireEmailVerification = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.requireEmailVerification;
};

export const selectEnrollmentCashRewardsStatus = state => {
  const enrollment = selectEnrollment(state);

  return enrollment && enrollment.cashRewardsEnrollmentStatus;
};

export const selectActiveAccountEmail = state =>
  selectEnrollment(state)?.activeAccountEmail;

export const selectActiveAccountLoginToken = state =>
  selectEnrollment(state)?.activeAccountLoginToken;

export const selectEnrollmentRedirectEligible = state =>
  selectEnrollment(state)?.enrollmentRedirectEligible;
